// LivestreamPinnedMessages.js
'use strict';
import { connect } from 'react-redux';

import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

import getLiveStreamData from '../selector/getLiveStreamData.js';
import getLiveStreamPinnedMessages from '../selector/getLiveStreamPinnedMessages.js';
import getOperationData from '../selector/getOperationData.js';

import LivestreamPinnedMessages from '../component/LivestreamPinnedMessages.jsx';

const mapStateToProps = (state, { streamId }) => {
  const sessionId = getLiveStreamData(state, [streamId], 'sessionId');
  return {
    sessionId,
    pinnedMessages: getLiveStreamPinnedMessages(state, streamId),
    title: getLiveStreamData(state, [streamId], 'title'),
    categories: getLiveStreamData(state, [streamId], 'categories'),
    isExpanded: getOperationData(
      state,
      ['liveStream', 'pinnedMessage', sessionId],
      'isExpanded'
    ),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setIsExpanded: ({ sessionId, isExpanded }) =>
      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['liveStream', 'pinnedMessage', sessionId],
          data: {
            isExpanded,
          },
        },
      }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LivestreamPinnedMessages);
